export { default as config } from './config';
export { default as GlobalStyles } from './styles/global-styles';
export {
    rem,
    subtract1Px,
    setSizes,
    gradient,
    checkTheme,
    positionArrow,
    calcSize,
    fontWeight,
    getResponsiveImage,
    conflictColor
} from './styles/mixins';
